"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Link = _interopRequireDefault(require("../Link"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Dependencies

// Main class export
class Support extends _react.default.Component {
  constructor() {
    super();
    this.state = {
      visible: false
    };
  }
  renderLinks() {
    const styles = {
      color: '#999',
      fontSize: '13px',
      marginRight: '14px',
      padding: '8px 0',
      textDecoration: 'none',
      letterSpacing: '1.2px',
      transition: 'all 0.2s ease-in-out'
    };
    const hoverStyles = {
      color: '#00a9f2'
    };
    return this.props.links.map((link, i) => {
      if (!link.href) {
        return /*#__PURE__*/_react.default.createElement("span", {
          key: i,
          style: styles
        }, link.text);
      }
      return /*#__PURE__*/_react.default.createElement("span", {
        key: i
      }, /*#__PURE__*/_react.default.createElement(_Link.default, {
        href: link.href,
        style: styles,
        hoverStyles: hoverStyles
      }, link.text));
    });
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "support-section",
      style: {
        padding: '0 0 7px 0'
      }
    }, this.renderLinks());
  }
}
exports.default = Support;
;
Support.propTypes = {
  links: _propTypes.default.array,
  selector: _propTypes.default.object,
  selectorText: _propTypes.default.string,
  modelTitle: _propTypes.default.string,
  isMobile: _propTypes.default.bool
};
Support.defaultProps = {
  links: []
};